import { AnswerAlternatives, AnswerID, QuestionID } from "./questions";
import { QuantizedScore } from "./search";
export function formatDuration(duration) {
    let minutes = 0;
    if (duration < 60 * 60) {
        minutes = 5 * Math.ceil(duration / 60 / 5);
    }
    else if (duration < 60 * 60 * 10) {
        minutes = 30 * Math.round(duration / 60 / 30);
    }
    else {
        minutes = 60 * Math.round(duration / 60 / 60);
    }
    let hours = Math.floor(minutes / 60);
    minutes -= hours * 60;
    if (hours == 0) {
        return "" + minutes + " min";
    }
    else if (minutes == 0) {
        return "" + hours + " tim";
    }
    else if (minutes == 30) {
        return "" + hours + ",5 tim ";
    }
    else {
        return "" + hours + " tim " + minutes + " min";
    }
}
export function formatDurationTooltip(resortCount) {
    if (resortCount == 1) {
        return "1 skidort";
    }
    else {
        return `${resortCount} skidorter`;
    }
}
export function formatMatchPercentage(matchPercentage) {
    return String(Math.round(matchPercentage)) + "%";
}
export function formatMatchPercentageTooltip(matchPercentage) {
    return formatMatchPercentage(matchPercentage) + " match för dig";
}
export const titleCase = (text) => {
    return text.charAt(0).toUpperCase() + text.substr(1).toLowerCase();
};
function get_child_friendliness_description(quantizedScore) {
    if (quantizedScore == QuantizedScore.BAD) {
        return "Ej barnvänligt";
    }
    if (quantizedScore == QuantizedScore.GOOD) {
        return "Barnvänligt";
    }
    if (quantizedScore == QuantizedScore.GREAT) {
        return "Mycket barnvänligt";
    }
    return "";
}
function get_offpist_description(quantizedScore) {
    if (quantizedScore == QuantizedScore.BAD) {
        return "Dålig offpist";
    }
    if (quantizedScore == QuantizedScore.GOOD) {
        return "Bra offpist";
    }
    if (quantizedScore == QuantizedScore.GREAT) {
        return "Mycket bra offpist";
    }
    return "";
}
function get_funpark_description(quantizedScore) {
    if (quantizedScore == QuantizedScore.BAD) {
        return "Ingen park";
    }
    if (quantizedScore == QuantizedScore.GOOD) {
        return "Bra park";
    }
    if (quantizedScore == QuantizedScore.GREAT) {
        return "Utmärkt park";
    }
    return "";
}
function get_beginner_friendliness_description(quantizedScore) {
    if (quantizedScore == QuantizedScore.BAD) {
        return "Svårt för nybörjare";
    }
    if (quantizedScore == QuantizedScore.GOOD) {
        return "Bra för nybörjare";
    }
    if (quantizedScore == QuantizedScore.GREAT) {
        return "Utmärkt för nybörjare";
    }
    return "";
}
function get_tough_slopes_description(quantizedScore) {
    if (quantizedScore == QuantizedScore.BAD) {
        return "Inte utmanande";
    }
    if (quantizedScore == QuantizedScore.GOOD) {
        return "Utmanande backar";
    }
    if (quantizedScore == QuantizedScore.GREAT) {
        return "Utmanande backar";
    }
    return "";
}
function get_long_slopes_description(quantizedScore) {
    if (quantizedScore == QuantizedScore.BAD) {
        return "Korta backar";
    }
    if (quantizedScore == QuantizedScore.GOOD) {
        return "Långa backar";
    }
    if (quantizedScore == QuantizedScore.GREAT) {
        return "Mycket långa backar";
    }
    return "";
}
function get_cross_country_description(quantizedScore) {
    if (quantizedScore == QuantizedScore.BAD) {
        return "Ej längdskidor";
    }
    if (quantizedScore == QuantizedScore.GOOD) {
        return "Bra längdskidspår";
    }
    if (quantizedScore == QuantizedScore.GREAT) {
        return "Utmärkta längdspår";
    }
    return "";
}
function get_afterski_description(quantizedScore) {
    if (quantizedScore == QuantizedScore.BAD) {
        return "Dålig afterski";
    }
    if (quantizedScore == QuantizedScore.GOOD) {
        return "Bra afterski";
    }
    if (quantizedScore == QuantizedScore.GREAT) {
        return "Utmärkt afterski";
    }
    return "";
}
function quantized_score_to_value(quantizedScore) {
    if (quantizedScore == QuantizedScore.BAD) {
        return -1;
    }
    if (quantizedScore == QuantizedScore.GOOD) {
        return 1;
    }
    if (quantizedScore == QuantizedScore.GREAT) {
        return 2;
    }
    return 0;
}
const isAspectRelevant = (answered, questionID, answerID) => {
    if (answered == null) {
        return true;
    }
    const answeredQuestion = answered.getByID(questionID);
    const answer = answeredQuestion.answer;
    if (answer instanceof AnswerAlternatives) {
        return answer.selected.has(answerID);
    }
    return true;
};
export const calculateProsCons = (x, answered) => {
    let output = [];
    if (isAspectRelevant(answered, QuestionID.OtherRecreation, AnswerID.ChildFriendly)
        && x.child_friendliness != QuantizedScore.NEUTRAL) {
        output.push({
            score: x.child_friendliness,
            description: get_child_friendliness_description(x.child_friendliness),
        });
    }
    if (isAspectRelevant(answered, QuestionID.ImportantSlopeAttributes, AnswerID.OffPiste)
        && x.offpist_score != QuantizedScore.NEUTRAL) {
        output.push({
            score: x.offpist_score,
            description: get_offpist_description(x.offpist_score),
        });
    }
    if (isAspectRelevant(answered, QuestionID.ImportantSlopeAttributes, AnswerID.Park)
        && x.funpark_score != QuantizedScore.NEUTRAL) {
        output.push({
            score: x.funpark_score,
            description: get_funpark_description(x.funpark_score),
        });
    }
    if (isAspectRelevant(answered, QuestionID.ImportantSlopeAttributes, AnswerID.BeginnerFriendly)
        && x.beginner_friendliness != QuantizedScore.NEUTRAL) {
        output.push({
            score: x.beginner_friendliness,
            description: get_beginner_friendliness_description(x.beginner_friendliness),
        });
    }
    if (isAspectRelevant(answered, QuestionID.ImportantSlopeAttributes, AnswerID.ToughSlopes)
        && x.tough_slopes_score != QuantizedScore.NEUTRAL) {
        output.push({
            score: x.tough_slopes_score,
            description: get_tough_slopes_description(x.tough_slopes_score),
        });
    }
    if (isAspectRelevant(answered, QuestionID.ImportantSlopeAttributes, AnswerID.LongWindingSlopes)
        && x.long_slopes_score != QuantizedScore.NEUTRAL) {
        output.push({
            score: x.long_slopes_score,
            description: get_long_slopes_description(x.long_slopes_score),
        });
    }
    if (isAspectRelevant(answered, QuestionID.ImportantSlopeAttributes, AnswerID.CrossCountry)
        && x.cross_country_score != QuantizedScore.NEUTRAL) {
        output.push({
            score: x.cross_country_score,
            description: get_cross_country_description(x.cross_country_score),
        });
    }
    if (isAspectRelevant(answered, QuestionID.OtherRecreation, AnswerID.AfterSki)
        && x.afterski_score != QuantizedScore.NEUTRAL) {
        output.push({
            score: x.afterski_score,
            description: get_afterski_description(x.afterski_score),
        });
    }
    for (let item of output) {
        item.description = titleCase(item.description);
    }
    output.sort((a, b) => (quantized_score_to_value(b.score) - quantized_score_to_value(a.score)));
    return output;
};
export function formatURL(url) {
    const u = new URL(url);
    let host = u.host;
    host = host.replace(/^www\./, "");
    return `${host}`;
}
export var SlopeColor;
(function (SlopeColor) {
    SlopeColor[SlopeColor["Green"] = 0] = "Green";
    SlopeColor[SlopeColor["Blue"] = 1] = "Blue";
    SlopeColor[SlopeColor["Red"] = 2] = "Red";
    SlopeColor[SlopeColor["Black"] = 3] = "Black";
    SlopeColor[SlopeColor["Unpisted"] = 4] = "Unpisted";
})(SlopeColor || (SlopeColor = {}));
export function formatNumSlopes(numRuns, slopeColor) {
    const numRunsFormatted = numRuns !== null ? String(numRuns) : "?";
    if (numRuns == 1) {
        switch (slopeColor) {
            case SlopeColor.Green: return '1 mycket lätt backe';
            case SlopeColor.Blue: return '1 lätt backe';
            case SlopeColor.Red: return '1 medelsvår backe';
            case SlopeColor.Black: return '1 svår backe';
            case SlopeColor.Unpisted: return '1 opistad backe';
            default: return '1 backe';
        }
    }
    else {
        switch (slopeColor) {
            case SlopeColor.Green: return `${numRunsFormatted} mycket lätta backar`;
            case SlopeColor.Blue: return `${numRunsFormatted} lätta backar`;
            case SlopeColor.Red: return `${numRunsFormatted} medelsvåra backar`;
            case SlopeColor.Black: return `${numRunsFormatted} svåra backar`;
            case SlopeColor.Unpisted: return `${numRunsFormatted} opistade backar`;
            default: return `${numRunsFormatted} backar`;
        }
    }
}
